import { render, staticRenderFns } from "./InsuranceAccountCheck.vue?vue&type=template&id=507a4f07&scoped=true&"
import script from "./InsuranceAccountCheck.vue?vue&type=script&lang=js&"
export * from "./InsuranceAccountCheck.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceAccountCheck.vue?vue&type=style&index=0&id=507a4f07&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507a4f07",
  null
  
)

export default component.exports